import {
  getFirestore,
  collection,
  getDocs,
  query,
  deleteDoc,
  doc,
  getDoc,
  orderBy,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Outlet, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router'
import Alert from '@mui/material/Alert';
import MachineMenu from './MachineMenu'


function MachineErrors() {
  let params = useParams();
  const machineId = params.machineId;
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [errors, setErrors] = useState({});
  const [productNames, setProductNames] = useState(null);
  const navigate = useNavigate();
  const [machine, setMachine] = useState(null);
  const location = useLocation();

  const handleClose = () => {
    setOpen(false);
  };

  function fetchData() {
    getDocs(
      query(collection(getFirestore(), `machines/${machineId}/errors`), orderBy("timestamp", "desc"))
    ).then( (querySnapshot) => {
      let errors = [];
     
      querySnapshot.forEach((doc) => {
        let data = doc.data();
        console.log(data);
        data.id = doc.id;
        errors[doc.id] = data;
      });

      

      // Update the state with the resolved 
      setErrors(errors);
      
    });
  }


  function fetchMachineData() {

        
    getDoc(doc(getFirestore(), "machines", machineId)).then(
        (docSnap) => {
            let machine = docSnap.data();
            
          setMachine(docSnap.data());
        }
      );



   
    
      
  }
  useEffect(() => {
    fetchData();
  }, [location.key])

  useEffect(() => {
    fetchData()
    fetchMachineData();
  }, [machineId]);


  return (
    <div>
              {MachineMenu(machine, machineId)}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell width={20}></TableCell>
              <TableCell>Timestamp</TableCell> 
              <TableCell>Status</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {Object.values(errors).map((error) => (
                  <TableRow key={error.id}>
                    <TableCell>{error.status ==1?<Alert severity="error"></Alert>:<Alert severity="success"></Alert>}</TableCell>
                    <TableCell>{new Date(error.timestamp.seconds*1000).toLocaleString()}</TableCell>
                    <TableCell>
                      {error.error}
                    </TableCell>
                     
                    
                  </TableRow>
                ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Outlet />
     
    </div>
  );
}

export default MachineErrors;
